import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "./components/Layout";
import About from "./pages/About";
import Home from "./pages/Home";
import Shop, { loader as shopLoader } from "./pages/Shop";
// import ProfitLoss from "./pages/ProfitLoss";
// import { CartProvider } from "./components/CartContext";
import Cart from "./pages/Cart";
import FAQs from "./pages/FAQs";
import Contact from "./pages/Contact";
import Item, { loader as itemLoader } from "./pages/Item";
import AuthRequired, { loader as authLoader } from "./components/AuthRequired";
import Login, { action as loginAction } from "./pages/Login";
import EmailsManagement, {
  loader as emailsManagementLoader,
} from "./pages/EmailsManagement";
import Design from "./pages/Design";
import ReturnsAndExchanges from "./pages/ReturnsAndExchanges";
import LegalAndCookiesLayout from "./components/LegalAndCookiesLayout";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ReturnsAndExchangesManagement, {
  loader as returnsAndExchangesManagementLoader,
} from "./pages/ReturnsAndExchangesManagement";
import ContactsManagement, {
  loader as contactsManagementLoader,
} from "./pages/ContactsManagement";
import OrdersManagement, {
  loader as ordersManagementLoader,
} from "./pages/OrdersManagement";
import ManagementLayout from "./components/ManagementLayout";
import ErrorPage from "./pages/ErrorPage";
import StockManagement, {
  loader as stockManagementLoader,
} from "./pages/StockManagement";
import AffiliateCodesManagement, {
  loader as affiliateCodesManagementLoader,
} from "./pages/AffiliateCodesManagement";
import AffiliateThroughputManagement, {
  loader as affiliateThroughputManagementLoader,
} from "./pages/AffiliateThroughputManagement";
import useGTMPageView from "./components/useGTMPageView";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Layout />} errorElement={<ErrorPage />}>
        <Route index element={<Home />} />
        <Route path="about-us" element={<About />} />
        <Route path="shop" element={<Shop />} loader={shopLoader} />
        <Route path="shop/:id" element={<Item />} loader={itemLoader} />
        <Route path="cart" element={<Cart />} />
        <Route path="faqs" element={<FAQs />} />
        <Route path="contact" element={<Contact />} />
        <Route path="login" element={<Login />} action={loginAction} />
        <Route path="design" element={<Design />} />
        <Route path="returns-and-exchanges" element={<ReturnsAndExchanges />} />
        <Route path="legal-and-cookies" element={<LegalAndCookiesLayout />}>
          <Route index element={<TermsAndConditions />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
        </Route>
        <Route element={<AuthRequired />} loader={authLoader}>
          <Route path="management" element={<ManagementLayout />}>
            <Route
              path="contacts"
              element={<ContactsManagement />}
              loader={contactsManagementLoader}
            />
            <Route
              path="orders"
              element={<OrdersManagement />}
              loader={ordersManagementLoader}
            />
            <Route
              path="emails"
              element={<EmailsManagement />}
              loader={emailsManagementLoader}
            />
            <Route
              path="returns"
              element={<ReturnsAndExchangesManagement />}
              loader={returnsAndExchangesManagementLoader}
            />
            <Route
              path="stock"
              element={<StockManagement />}
              loader={stockManagementLoader}
            />
            <Route
              path="affiliates"
              element={<AffiliateCodesManagement />}
              loader={affiliateCodesManagementLoader}
            />
            <Route
              path="affiliates-throughput"
              element={<AffiliateThroughputManagement />}
              loader={affiliateThroughputManagementLoader}
            />
          </Route>
        </Route>
      </Route>
    </Route>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
